$(function() {

    $.end = {};

    // durations

    $.end.duration = '50%';

    $.end.pinDuration = 0;

    $.end.logoDuration = '50%';

    // timelines

    $.end.tl = {};

    // in

	$.end.tl.in = new TimelineMax();

    $.end.tl.in.addLabel("start");
    $.end.tl.in.addLabel("content", 2);

    $.end.tl.in.set("#end-section", { visibility: "visible" }, "start");﻿

    $.end.tl.in.fromTo("#end-background", 1, { opacity:0 }, { opacity:1 }, "start");

    new ScrollMagic.Scene({ triggerElement: '#end-pin', triggerHook: 'onLeave', duration: $.end.duration })
    	.setTween($.end.tl.in)
    	// .addIndicators({name: 'end in'})
    	.addTo($.controller);

    new ScrollMagic.Scene({ triggerElement: '#end-pin', triggerHook: 'onLeave', duration: $.end.pinDuration })
        .setPin('#end-background')
        // .addIndicators({name: 'end pin'})
        .addTo($.controller);

    // logo

    $.end.tl.logo = new TimelineMax();

    $.end.tl.logo.addLabel("start");
    $.end.tl.logo.addLabel("logo", 1.5);
    $.end.tl.logo.addLabel("statement", 2.5);

    $.end.tl.logo.from("#end-section .lu-logo-shield", 1, { opacity: 0, scaleX: 0, transformOrigin: "50% 50%", ease:Cubic.easeOut }, "logo");
	$.end.tl.logo.staggerFrom("#end-section .lu-logo-lakehead path", 1, { opacity: 0, ease:Cubic.easeIn }, 0.015, "logo");
	$.end.tl.logo.staggerFrom("#end-section .lu-logo-university path", 1, { opacity: 0, delay: 0.25, ease:Cubic.easeIn }, 0.015, "logo");

    $.end.tl.logo.staggerFrom("#end-section .lu-statement path", 0.01, { opacity: 0, ease:Cubic.easeIn }, 0.1, "statement");

    new ScrollMagic.Scene({ triggerElement: '#end-trigger', triggerHook: 'onCenter', duration: $.end.logoDuration })
    	.setTween($.end.tl.logo)
    	// .addIndicators({name: 'end logo'})
    	.addTo($.controller);

});
